import { useContext } from 'react';
import { Tablist, Tab } from '@pelckmans/business-components/components/tabs';
import WordlistFavoritesTab from './WordlistFavoritesTab';
import WordlistLanguageSelector from './WordlistLanguageSelector';
import WordlistListTab from './WordlistListTab';
import WordlistPreview from './WordlistPreview';
import WordlistSearchTab from './WordlistSearchTab';
import WordlistContext, { WordlistTab } from './_contexts/WordlistContext';
import useWordlistWords from './_hooks/useWordlistWords';

export default function WordlistListMode() {
  const { currentTab, handleTabChange } = useContext(WordlistContext);
  const words = useWordlistWords();

  return (
    <>
      <Tablist align="vertical">
        <Tab
          id={WordlistTab.LIST}
          selected={currentTab === WordlistTab.LIST}
          onClick={() => handleTabChange(WordlistTab.LIST)}
        >
          <svg className="icon icon-wordlist" role="img">
            <use href="#icon-wordlist" />
          </svg>
        </Tab>
        <Tab
          id={WordlistTab.FAVORITES}
          selected={currentTab === WordlistTab.FAVORITES}
          onClick={() => handleTabChange(WordlistTab.FAVORITES)}
        >
          <svg className="icon icon-star" role="img">
            <use href="#icon-star" />
          </svg>
        </Tab>
        <Tab
          id={WordlistTab.SEARCH}
          selected={currentTab === WordlistTab.SEARCH}
          onClick={() => handleTabChange(WordlistTab.SEARCH)}
        >
          <svg className="icon icon-search" role="img">
            <use href="#icon-search" />
          </svg>
        </Tab>
      </Tablist>
      <div className="container-fluid wordlist__container">
        <div className="row">
          <div className="col-lg-5 wordlist__column wordlist__content">
            <WordlistLanguageSelector />

            {currentTab === WordlistTab.LIST && <WordlistListTab />}
            {currentTab === WordlistTab.FAVORITES && <WordlistFavoritesTab />}
            {currentTab === WordlistTab.SEARCH && <WordlistSearchTab />}
          </div>

          <div className="col-lg-7 wordlist__column wordlist__preview-wrapper" data-testid="wordlist__preview">
            <WordlistPreview words={words} />
          </div>
        </div>
      </div>
    </>
  );
}
